import _ from "lodash";
import { useState, useEffect } from "react";
import '../assets/styles/Game.css';
import Header from "./Header";
import Row from './Row';
import RowZero from "./RowZero";
import RowSolution from './RowSolution';

const Game = () => {
  const allColors =['green', 'orange', 'yellow','blue','brown', 'magenta'];
  const pickRandomColors = () => {
    // This was for choosing 4 different colors
    // const shuffled = _.clone(allColors).sort(() => 0.5 - Math.random());
    // return shuffled.slice(0,4);
    const shuffled = [];
    for (let i=0; i < 4; i++) {
      shuffled[i] = allColors[Math.floor(Math.random()*6)];
    }
    return shuffled;
  }

  const [currentID, setCurrentID] = useState(1);
  const [currentColors, setCurrentColors] = useState(['', '','','']);
  const [randomColors, setRandomColors] = useState(() => pickRandomColors());
  const [checkWinner, setCheckWinner] = useState(false);
  const [winner, setWinner] = useState(false);
  const [looser, setLooser] = useState(false);
  const [selectedColor, setSelectedColor] = useState('');
  const [resetPegs, setResetPegs] = useState(false);
  const IDs = _.range(1,11);


  const handleClick = (ev) => {
    // Get ID row and place of peg
    const clickedID = ev.currentTarget.id;
    // Split into array
    const clickedIDs = _.split(clickedID,'-');
    // Check, if it is row we are playing now
    if (Number(clickedIDs[0]) === currentID && selectedColor !== '') {
      // Make a copy of current colors array
      let newColors = _.clone(currentColors);
      // Set new color to place
      const pegID = clickedIDs[1];
      newColors[pegID] = selectedColor;
      setCurrentColors(newColors);
      // Release selected color
      // Requirement to remain selected
      // setSelectedColor('');
    }
  }  

  const newGame = () => {
    setCurrentID(1);
    setCurrentColors(['', '','','']);
    setRandomColors(pickRandomColors());
    setCheckWinner(false);
    setWinner(false);
    setLooser(false);
    setSelectedColor('');
    setResetPegs(true);
    setTimeout(() => setResetPegs(false), 100);
  };

  useEffect(() => {
    if (checkWinner === true) {
      if ((currentColors.map((col, i) => col === randomColors[i]).filter((res) => res === true).length) === 4) 
      {
        setWinner(true);
      } else if (currentID === 10) {
        setLooser(true);
      } else {
        setCurrentID(currentID + 1);
        setCheckWinner(false);
        setCurrentColors(['','','','']);
      }
    }
  },[checkWinner, currentColors, currentID, randomColors]);

  return (
    <div className="game">
      <Header />
      <RowZero setSelectedColor={setSelectedColor} allColors={allColors} selectedColor={selectedColor} />
      {(IDs.map((i) => <Row key={i} handleClick={handleClick} id={i} currentID={currentID} currentColors={currentColors} 
          randomColors={randomColors} setCurrentID={setCurrentID} setCheckWinner={setCheckWinner} resetPegs={resetPegs} />))}
      {(winner) && <div className="winningMessage">You Won!</div>}
      {(looser) && (
      <div>
        <div className="loosingMessage">You Lost</div>
        <div className="loosingMessage">Solution:</div>
        <RowSolution currentColors={randomColors}/>
      </div>  
      )}
      {(winner || looser) && <div className="playAgain" onClick={() => {newGame()}}>Play Again?</div>}
    </div>
  )

}

export default Game;